import { useState } from "react";
import { useParams } from "react-router-dom";

import { StripeCheckout } from "../../components/stripe/StripeCheckout";
import { createPaymentIntent } from "../../api/stripeApi";

export default function PaymentCreatePage() {
    const { shipmentId } = useParams();

    const [amount, setAmount] = useState("");
    const [clientSecret, setClientSecret] = useState(null);
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const startPayment = async () => {
        if (!shipmentId) {
            setError("Shipment id is missing.");
            return;
        }

        try {
            setLoading(true);
            setError("");

            const payload = {
                shipmentId: Number(shipmentId),
                amount: amount ? Number(amount) : null,
                currency: "eur"
            };

            const result = await createPaymentIntent(payload);
            setClientSecret(result.clientSecret);
        } catch (e) {
            setError(
                e?.response?.data?.message ||
                e?.message ||
                "Failed to prepare payment."
            );
        } finally {
            setLoading(false);
        }
    };

    if (error) {
        return <p className="text-red-600 text-center mt-6">{error}</p>;
    }

    if (clientSecret) {
        return (
            <StripeCheckout clientSecret={clientSecret} />
        );
    }

    return (
        <div className="max-w-md mx-auto p-6 bg-white rounded shadow">
            <h2 className="text-xl font-bold mb-4">Payment</h2>

            <p className="text-sm text-gray-600 mb-3">
                Leave amount empty to pay the full remaining balance.
            </p>

            <input
                type="number"
                step="0.01"
                min="0"
                placeholder="Partial amount"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                className="border p-2 w-full rounded mb-3"
            />

            <button
                type="button"
                onClick={startPayment}
                disabled={loading}
                className="bg-indigo-600 text-white px-4 py-2 rounded w-full disabled:opacity-60"
            >
                {loading ? "Preparing..." : "Continue to payment"}
            </button>
        </div>
    );
}